import { IconName } from 'Components/foundation/icons';

export const swipingCardsIconMap = new Map<number, IconName[]>([
  [2, ['arrow-left', 'arrow-right']],
  [3, ['arrow-left', 'arrow-right', 'arrow-down-bis']],
  [4, ['arrow-top-left', 'arrow-bottom-right', 'arrow-bottom-left', 'arrow-top-right']],
]);
